import { FC, HTMLAttributes, memo, useCallback, useState } from 'react';
import cn from 'classnames';

import useMedias from '@Hooks/useMedias';
import useInfiniteWikiArticles from '@Queries/useInfiniteWikiArticles';
import WikiPopularTags from '@Components/WikiPopularTags';
import WikiArticlesCatalog from '@Components/WikiArticlesCatalog';
import { PageWikiRubricData } from './typings';
import styles from './PageWikiRubric.module.css';
import RecommendedArticles from './elements/RecommendedArticles';

export interface PageWikiRubricProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  page: PageWikiRubricData;
}

const PageWikiRubric: FC<PageWikiRubricProps> = (props) => {
  const { className, page, ...restProps } = props;
  const { recommendedArticles, popularTags, fetchUrl } = page;
  // TODO:backend передавать нам идентификатор категории, вместо того чтобы передавать адрес для загрузки данных
  const params = new URLSearchParams(fetchUrl.split('?')[1]);
  const categoryId = params.get('categoryId');
  const { isMobile } = useMedias();
  const defaultCountRows = isMobile ? 15 : 8;
  const [countRows, setCountRows] = useState(defaultCountRows);
  const category = useInfiniteWikiArticles({ categoryId });

  const handleMore = useCallback(async () => {
    if (category.isFetching || !category.hasNextPage) return;

    category.fetchNextPage();

    setCountRows((prevCountRows) => prevCountRows + defaultCountRows);
  }, [category, defaultCountRows]);

  if (!category.isSuccess) return null;

  return (
    <div {...restProps} className={cn(styles.pageWikiRubric, className)}>
      <RecommendedArticles className={styles.container} articles={recommendedArticles}>
        {popularTags?.length > 0 && (
          <WikiPopularTags tags={popularTags} className={styles.popularTags} />
        )}
      </RecommendedArticles>

      <WikiArticlesCatalog
        className={cn(styles.articlesCatalog)}
        category={category}
        countRows={countRows}
        onMore={handleMore}
      />
    </div>
  );
};

export default memo(PageWikiRubric);
